import React from 'react';
import Chip, { ChipSizes, ChipTypes } from '@lib/components/Chip/Chip';
import styles from './SsoPresetChip.module.scss';

export interface Props {
  icon: string | undefined;
  label: React.ReactNode;
}

function SsoPresetChip({ icon, label }: Props) {
  return (
    <Chip
      type={ChipTypes.chipGray}
      label={label}
      leftImage={icon}
      leftImageClassName={styles.avatarImage}
      leftImageRounded
      rounded
      size={ChipSizes.medium}
    />
  );
}

export default SsoPresetChip;
